import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "@/constants/contact";

const CARDS = [
  {
    icon: Phone,
    label: "Call us",
    value: CONTACT.phoneDisplay,
    href: `tel:+91${CONTACT.phone}`,
    testId: "contact-phone",
  },
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: "Chat with us",
    href: CONTACT.whatsapp("Hi eBikeGo team, I have a question."),
    testId: "contact-whatsapp",
  },
  {
    icon: Mail,
    label: "Email",
    value: CONTACT.email,
    href: `mailto:${CONTACT.email}`,
    testId: "contact-email",
  },
];

const Contact = () => (
  <div className="min-h-screen bg-[#F8F9FA]" data-testid="contact-page">
    <Navbar />

    <div className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
        <p className="text-[10px] uppercase tracking-widest text-[#2D7FF9] font-bold font-mono-num">— Contact Us</p>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl mt-3 tracking-tight text-ink">
          We&apos;d love to hear from you.
        </h1>
        <p className="text-gray-600 mt-4 max-w-2xl text-[15px] leading-relaxed">
          Questions about a booking, business enquiries or feedback — reach out
          on the channel that works for you. Our team responds within 24 hours
          on business days.
        </p>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-6">
      {CARDS.map(({ icon: Icon, label, value, href, testId }) => (
        <a
          key={label}
          href={href}
          data-testid={testId}
          target={href.startsWith("http") ? "_blank" : undefined}
          rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
          className="card-premium p-7 flex items-start gap-5 hover:-translate-y-0.5 hover:shadow-lg transition-all"
        >
          <div className="w-12 h-12 rounded-xl bg-brand-gradient flex items-center justify-center text-white shrink-0">
            <Icon size={20} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">{label}</p>
            <p className="font-display font-bold text-lg mt-1 text-ink break-words">{value}</p>
          </div>
        </a>
      ))}

      <div className="card-premium p-7 md:col-span-3">
        <div className="flex items-start gap-5">
          <div className="w-12 h-12 rounded-xl bg-brand-gradient flex items-center justify-center text-white shrink-0">
            <MapPin size={20} />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">Office Address</p>
            <p className="font-display font-bold text-lg mt-1 text-ink">Think eBikeGo Private Limited</p>
            <p className="text-sm text-gray-600 mt-2 leading-relaxed max-w-2xl">
              {CONTACT.address}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
);

export default Contact;
